// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"z5IZq5GKih","breadcrumbs-container":"wSIzAIPL1U","breadcrumbsContainer":"wSIzAIPL1U"};